import React, { useContext, useState } from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../layout/footer/Footer';
import Header from '../../layout/header/Header';
import { loginAdmin } from '../../features/auth/api/authApi';
import { GlobalContext } from '../../store/GlobalContext';
import { useI18n } from '../../i18n/I18nContext';

const AdminLogin = () => {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(GlobalContext);
  const { t } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location?.state?.from?.pathname || '/admin';

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');

    if (!usernameOrEmail || !password) {
      setError(t('login_all_fields_required'));
      return;
    }

    try {
      const result = await loginAdmin({ usernameOrEmail, password });
      if (result.accessToken) {
        login(result.accessToken, result.user, result.refreshToken);
        navigate(from, { replace: true });
      }
    } catch (err: any) {
      setError(err?.response?.data?.message || t('login_failed'));
    }
  };

  return (
    <>
      <Header />
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={6}>
            <h2 className="text-center mb-4">{t('login_admin_title')}</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="adminLoginUsername">
                <Form.Label>{t('login_username_email')}</Form.Label>
                <Form.Control
                  type="text"
                  value={usernameOrEmail}
                  onChange={(e) => setUsernameOrEmail(e.target.value)}
                  placeholder={t('login_username_email')}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="adminLoginPassword">
                <Form.Label>{t('login_password')}</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t('login_password')}
                  required
                />
              </Form.Group>

              <div className="d-grid mb-3">
                <Button variant="dark" type="submit">{t('login_sign_in_admin')}</Button>
              </div>

              <div className="text-center">
                <Button variant="link" onClick={() => navigate('/login')}>
                  {t('login_back_customer')}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default AdminLogin;
